import config from '@/config'

import useBackend from '@/hooks/useBackend'

function partnerWidget() {
  // HOOKS
  const { setup, doGet } = useBackend()

  // INIT
  setup('/partnerwidget', config.microserviceBaseUrl)

  // METHODS

  async function getBundle(__code, __language) {
    const response = await doGet(`/public/bundles/${__code}`, {}, false, { headers: { 'Accept-Language': __language } })
    return response.data
  }

  async function getCSSForBundle(code, lastModifiedDate) {
    const response = await doGet(`/public/bundle/${code}/css?v=${lastModifiedDate}`)
    return response.data
  }

  /*
  function getCustomThemeCssUrl(__code, lastModifiedDate) {
    console.log("BASE URL: ", getBaseUrl)
    return Promise.resolve(buildURL(`${getBaseUrl}/public/bundles/${__code}/css?v=${lastModifiedDate}`))
  }
*/

  return {
    getBundle,
    getCSSForBundle,
    // getCustomThemeCssUrl,
  }
}

export default partnerWidget()
